import React from 'react';

import EfeModal from 'components/efe-modal/EfeModal';
import ErrorTemplate from 'components/templates/alert/ErrorTemplate';
import {ErrorResponse} from 'commons/models/dtos';
import {AlertActions, SnackbarVariants} from 'commons/constants';
import {useSnackbar} from 'notistack';
import {Utils} from 'commons';
import {Grid, Typography} from '@material-ui/core';

type Props = {
    open: boolean;
    reactElement?: JSX.Element;
    actions?: Array<string>;
    error: any;
    defaultError: string;
    handleAction?: (action?: string) => void;
};

const baseError = {
    process: '',
    errors: [],
    message: '',
};

export default function EfeModalMsg(props: Props) {
    const {error, open, defaultError, handleAction, actions, reactElement} = props;
    const [customError, setCustomError] = React.useState<boolean>(false);
    const [data, setData] = React.useState<ErrorResponse>(baseError);
    const {enqueueSnackbar} = useSnackbar();

    React.useEffect(() => {
        if (error && Utils.functions.isCustomErrorService(error)) {
            setCustomError(true);
            setData(error.data);
        } else if (undefined !== actions || undefined !== reactElement) {
            setCustomError(true);
        } else {
            enqueueSnackbar(defaultError, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }, [error]);

    const CustomBody = () => {
        let bodyElement: JSX.Element;
        if (reactElement) {
            bodyElement = reactElement;
        } else if (defaultError && undefined !== actions) {
            bodyElement = (
                <Grid
                    container
                    spacing={2}
                    alignContent='center'
                    justifyContent='center'
                    direction='row'
                    className='mb-3'>
                    <Grid item xs={12} sm={12} md={12}>
                        <Typography variant='subtitle1' align='center'>
                            {defaultError}
                        </Typography>
                    </Grid>
                </Grid>
            );
        } else {
            bodyElement = (
                <ErrorTemplate
                    error={{
                        process: data.process || '',
                        errors: data.errors || [],
                        message: data.message || '',
                    }}
                    defaultMessage={''}
                />
            );
        }
        return bodyElement;
    };

    return (
        <>
            {customError && (
                <EfeModal
                    open={open}
                    title={'¡Aviso!'}
                    sizeOverride={30}
                    reactElement={<CustomBody />}
                    actions={actions ? actions : [AlertActions.OK]}
                    handleAction={handleAction}
                />
            )}
        </>
    );
}
